import React, { useState, useEffect, useContext } from "react";

//package import

import {
  Typography,
  Box,
  useTheme,
  TextField,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Chip,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
  Pagination,
  Paper,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Menu,
  Avatar,
  Grid,
  IconButton,
  Modal,
  Stack,
  Tooltip,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import {
  Logout as LogoutIcon,
  SignalWifiStatusbarNullTwoTone,
} from "@mui/icons-material";

// user imports

import { RoutesUrls, ministryRoutes } from "../../../Services/Routes/APP";
import { useNavigate } from "react-router-dom";
import { PROVINCE_API_ULRS } from "../../../Services/Routes/API";
import { headersPost } from "../../../Services/API";
import { getPagination } from "../../../common/functions";
import { ministry_Context } from "../../../context";
import { DetailsIcon, Users } from "../../../Svg";
import { useDecodedToken } from "../../../Services/Routes/APP/PrivateRoute";
import { fil } from "date-fns/locale";
import { border } from "@mui/system";

//constants

const headings = ["Name", "Population", "Population Served", "Action"];
const usersHeading = ["Name", "Email", " Status"];

//component

const District = () => {
  //hooks

  const theme = useTheme();
  const navigate = useNavigate();
  const user = useDecodedToken();

  // States
  const [page, setPage] = useState(1);
  const [districts, setDistricts] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [api, setApi] = useState(false);
  const [alertIcon, setAlertIcon] = useState("error");
  const [filteredDistrict, setFilteredDistrict] = useState([]);
  const [district, setDistrict] = useState([]);
  const [searched, setSearched] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [usersModalOpen, setUsersModalOpen] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [searchData, setSearchData] = useState("");

  const openn = Boolean(anchorEl);

  //constants

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  //menu close handler

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logoutHandler = () => {
    localStorage.clear();
    navigate(RoutesUrls?.root);
  };

  // Get All Districts

  const getDistricts = () => {
    const data = {
      page: page,
    };
    setOpen(true);

    headersPost(PROVINCE_API_ULRS.GET_ALL_DISTRICT, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setDistrict(res?.data?.districts);
          setFilteredDistrict(res?.data?.districts);
          setTotalCount(res?.data?.total_count);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  //life cycle

  useEffect(() => {
    getDistricts();
  }, [api]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setApi(true);
  };
  //close alert

  // Constants

  const detailsHandler = (row) => {
    navigate(RoutesUrls.ministryAdmin + ministryRoutes.detailsDistrict, {
      state: {
        node: row,
      },
    });
  };
  const requestSearch = (searchedVal) => {
    const filteredRows = district.filter((row) => {
      return row.name.toLowerCase().includes(searchedVal.toLowerCase());
    });
    setFilteredDistrict(filteredRows);
  };
  // user modal handlers

  const usersHandler = (users) => {
    setUsersModalOpen(true);
    setUsersList(users);
  };
  const usersHandlerClose = () => {
    setUsersModalOpen(false);
    setUsersList([]);
  };
  // render

  return (
    <Box>
      {/* <Paper elevation={1} borderRadius={1}>
        <Grid container>
          <Grid
            item
            xs={8}
            sm={8}
            md={8}
            lg={8}
            sx={{ p: 1 }}
            alignItems={"center"}
          >
            <Typography
              variant="h5"
              m={0.5}
              sx={{
                fontWeight: "bold",
                color: theme.palette.text.light,
                marginTop: theme.spacing(1.5),
                marginLeft: theme.spacing(2),
              }}
            >
              {user?.name}
            </Typography>
            <Typography variant="h5" color={"text.grayText"} ml={2} mt={1.5}>
              Districts
            </Typography>
          </Grid>
          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            lg={4}
            display={"flex"}
            justifyContent={"flex-end"}
          >
            <Typography
              mt={3}
              sx={{
                textTransform: "capitalize",
              }}
            >
              {user?.name}
            </Typography>
            <Box m={1} component={IconButton} onClick={handleClick}>
              <Avatar
                sx={{ width: "40px", height: "40px" }}
                src="/images/Australia.png"
              ></Avatar>
            </Box>
            <Menu
              anchorEl={anchorEl}
              open={openn}
              onClose={handleClose}
              onClick={handleClose}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem onClick={logoutHandler}>
                <ListItemIcon>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Logout</ListItemText>
              </MenuItem>
            </Menu>
          </Grid>
        </Grid>
      </Paper> */}
      <Box marginTop={2} mr={2} display={"flex"} justifyContent={"flex-end"}>
        <TextField
          size="small"
          type="search"
          placeholder="Search by name"
          value={searched}
          onChange={(e) => {
            setSearched(e.target.value);
            requestSearch(e.target.value);
          }}
          InputProps={{
            startAdornment: (
              <SearchIcon
                sx={{
                  color: theme.palette.primary.dark,
                }}
              />
            ),
          }}
          sx={{
            borderRadius: 25,
            backgroundColor: theme.palette.secondary.dark,
            [`.${outlinedInputClasses.root}`]: {
              borderRadius: 25,
              paddingX: 2,
            },
          }}
        ></TextField>
      </Box>
      <Box mt={2}>
        <Paper elevation={1}>
          <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  {headings?.map((h, index) => (
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                      }}
                      align="center"
                      key={`${index}-table-heading-${h}`}
                    >
                      <Chip
                        label={h}
                        sx={{
                          backgroundColor:
                            index === headings.length - 1
                              ? `${theme.palette.error.light}`
                              : `${theme.palette.secondary.dark}`,
                          borderRadius: 2,
                          color:
                            index === headings.length - 1
                              ? `${theme.palette.error.main}`
                              : `${theme.palette.primary.main}`,
                        }}
                      ></Chip>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredDistrict.length > 0 ? (
                  filteredDistrict?.map((row, index) => (
                    <TableRow key={`${index}-row.name-${index + 2}`}>
                      <TableCell
                        align="center"
                        sx={{ size: "small", wordWrap: "break-word" }}
                      >
                        {row?.name}
                      </TableCell>
                      <TableCell align="center">{row?.population}</TableCell>
                      <TableCell align="center">
                        {row?.vaccinated || 0}
                      </TableCell>
                      <TableCell align="center">
                        <Stack
                          direction="row"
                          spacing={1}
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Tooltip title="Details">
                            <Button
                              color="secondary"
                              variant="contained"
                              size="small"
                              onClick={() => detailsHandler(row)}
                              sx={{
                                borderRadius: 1,
                                minWidth: 2,

                                padding: 1,
                              }}
                            >
                              <DetailsIcon />
                            </Button>
                          </Tooltip>
                          <Tooltip title="Users">
                            <Button
                              color="primary"
                              variant="contained"
                              onClick={() => usersHandler(row?.users)}
                              sx={{
                                borderRadius: 1,

                                minWidth: 2,

                                padding: 1,
                              }}
                            >
                              <Users />
                            </Button>
                          </Tooltip>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    {" "}
                    <TableCell colSpan={4}>
                      {" "}
                      <Typography
                        variant="body1"
                        width={"100%"}
                        sx={{
                          textAlign: "center",
                        }}
                      >
                        No Data Found
                      </Typography>{" "}
                    </TableCell>{" "}
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <Box paddingTop={4} display={"flex"} justifyContent={"center"}>
              <Pagination
                count={totalCount > 10 ? getPagination(totalCount) : 1}
                page={page}
                onChange={handleChangePage}
                color="primary"
              />
            </Box>
          </TableContainer>
        </Paper>
      </Box>

      <Modal
        open={usersModalOpen}
        onClose={usersHandlerClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            minWidth: "50%",
            maxWidth: "90%",
            maxHeight: "80%",
            minHeight: "70%",
            boxShadow: 24,
            borderRadius: 3,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  {usersHeading?.map((h, index) => (
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                      }}
                      align="center"
                      key={`${index}-table-heading-${h}`}
                    >
                      <Chip
                        label={h}
                        sx={{
                          backgroundColor:
                            index === headings.length - 1
                              ? `${theme.palette.error.light}`
                              : `${theme.palette.secondary.dark}`,
                          borderRadius: 2,
                          color:
                            index === headings.length - 1
                              ? `${theme.palette.error.main}`
                              : `${theme.palette.primary.main}`,
                        }}
                      ></Chip>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {usersList?.map((row, index) => (
                  <TableRow key={`${index}-row.name-${index + 2}`}>
                    <TableCell
                      align="center"
                      sx={{
                        wordWrap: "break-word",
                      }}
                    >
                      {row?.name}
                    </TableCell>
                    <TableCell
                      sx={{
                        maxWidth: { xs: "80px", sm: "140px", md: "300" },
                        wordWrap: "break-word",
                      }}
                      align="center"
                    >
                      {row?.email}
                    </TableCell>

                    <TableCell align="center">
                      <Chip
                        label={row?.is_active ? "Not verified" : "Verified"}
                        sx={{
                          backgroundColor: row?.is_active
                            ? `${theme.palette.error.light}`
                            : `${theme.palette.success.light}`,

                          borderRadius: 2,
                          color: row?.is_active
                            ? `${theme.palette.error.main}`
                            : `${theme.palette.success.main}`,
                        }}
                      ></Chip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>

      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default District;
